import React, { useContext, useState } from "react";
import axios from "axios";
import { apiRoot } from "../../index";
import { UserContext } from "../../App";

export default function ImportBookingsData() {
  const { userInfos } = useContext(UserContext);

  const [bookingsFile, setBookingsFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [importStatus, setImportStatus] = useState(null);

  function handleBookingsFileChange(e) {
    const file = e.target.files[0];
    setBookingsFile(file);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (bookingsFile) {
      setIsUploading(true);
      setImportStatus(null);

      try {
        // Create FormData and append the file
        const formData = new FormData();
        formData.append("bookings", bookingsFile);

        // Send file to API for import
        const response = await axios.post(
          `${apiRoot}/api/v1/import/bookings`,
          formData,
          {
            headers: {
              Authorization: userInfos.jwt,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("Import réussi :", response.data);
        setImportStatus({
          success: true,
          message: `${response.data.imported} réservations importées avec succès sur ${response.data.total}.`,
        });

        // Clear form after successful import
        setBookingsFile(null);

        // Reset file input
        const fileInput = document.getElementById("bookings_file");
        if (fileInput) fileInput.value = "";
      } catch (error) {
        console.error("Erreur pendant l'import :", error);
        setImportStatus({
          success: false,
          message:
            "Erreur lors de l'importation : " +
            (error.response?.data?.error || error.message),
        });
      } finally {
        setIsUploading(false);
      }
    } else {
      setImportStatus({
        success: false,
        message: "Veuillez sélectionner un fichier CSV valide.",
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} encType="multipart/form-data">
      <div>
        Vous pouvez télécharger la trame d'import{" "}
        <a href="/zeplan-import-bookings.csv" download className="text-primary">
          <strong>ici</strong>
        </a>
        .<br />
        Et trouver{" "}
        <a href="/doc_import_bookings.pdf" download className="text-primary">
          <strong>ici</strong>
        </a>{" "}
        la documentation sur les champs attendus dans la trame.
      </div>

      <div className="form-group row">
        <label className="col-lg-3 col-form-label">
          Fichier de réservations :
        </label>
        <div className="col-lg-6 d-flex align-items-center">
          <input
            type="file"
            name="bookings"
            id="bookings_file"
            accept=".csv"
            onChange={handleBookingsFileChange}
            disabled={isUploading}
          />
        </div>
      </div>

      {importStatus && (
        <div className="form-group row">
          <div className="col-lg-9">
            <div className={`${importStatus.success ? "text-success" : "text-danger"}`}>
              {importStatus.message}
            </div>
          </div>
        </div>
      )}

      <div className="form-group row">
        <div className="col-lg-9 offset-lg-3">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!bookingsFile || isUploading}
          >
            {isUploading ? "Import en cours..." : "Importer"}
          </button>
          {!bookingsFile && (
            <>
              <br />
              <small className="text-muted">
                Veuillez sélectionner un fichier CSV contenant les réservations
                à importer.
              </small>
            </>
          )}
        </div>
      </div>
    </form>
  );
}
